import { ListType } from '@wdx/clmi/clmi-swagger-gen';
import { KeyValueObject } from '@wdx/shared/utils';

export const LIST_TYPE_MAP: Record<string, string> = {
    business: 'Business',
    compliance: 'OBA Group',
    family: 'Family',
    standard: 'List',
};
